class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.itemKey = this.dataset.itemKey;
    this.bindEvents();
  }

  bindEvents() {
    this.button.addEventListener('click', async () => {
      await this.removeItem();
    });
  }

  async removeItem() {
    const cartItem = this.closest('.cart-sidebar-list');

    try {
      // Add loading state
      this.button.disabled = true;
      cartItem.style.opacity = '0.5';

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.itemKey,
          quantity: 0
        })
      });

      if (!response.ok) {
        throw new Error('Failed to remove item');
      }

      const cartData = await response.json();

      // Animate item removal
      cartItem.style.height = cartItem.offsetHeight + 'px';
      cartItem.style.transition = 'all 0.3s ease-out';

      // Force browser to recognize the height
      getComputedStyle(cartItem).height;

      // Collapse and fade out
      cartItem.style.height = '0';
      cartItem.style.opacity = '0';
      cartItem.style.marginTop = '0';
      cartItem.style.marginBottom = '0';
      cartItem.style.padding = '0';

      // Update cart after item is removed
      const cartSidebar = this.closest('cart-sidebar');
      await cartSidebar.updateCart();

      // Show appropriate message
      if (cartData.item_count === 0) {
        window.commonCart.showToast('Cart is now empty');
      } else {
        window.commonCart.showToast('Item removed from cart');
      }

      // Remove the element after animation
      setTimeout(() => {
        cartItem.remove();
      }, 300);

    } catch (error) {
      // Reset loading state on error
      this.button.disabled = false;
      cartItem.style.opacity = '1';
      const cartSidebar = this.closest('cart-sidebar');
      window.commonCart.showToast('Failed to remove item', 'error');
    }
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

